import { isObject, isString, storage } from '@guardian/libs';
const participationsKey = 'gu.ab.participations';
const isParticipations = (participations) => {
    return (isObject(participations) &&
        Object.values(participations).every((participation) => isObject(participation) && isString(participation.variant)));
};
export const getParticipationsFromLocalStorage = () => {
    const participations = storage.local.get(participationsKey);
    return isParticipations(participations) ? participations : {};
};
export const setParticipationsInLocalStorage = (participations) => {
    storage.local.set(participationsKey, participations);
};
